import React from "react";
import { Input } from "reactstrap";
import { CONTRACT_TYPE_OPTIONS } from "../utils/contractTypeBadge";
import { PAYMENT_STATUS_OPTIONS } from "../utils/paymentStatus";

const ContractFilterBar = ({
  searchValue,
  onSearchChange,
  type,
  onTypeChange,
  paymentStatus,
  onPaymentStatusChange,
  phase,
  onPhaseChange,
  year,
  onYearChange,
  phases,
  years,
  hasAnyFilter,
  onClear,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 p-3 border-bottom">
      <Input
        type="text"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search PVC, client or notary"
        style={{ flex: "1 1 240px", minWidth: 0 }}
      />
      <Input
        type="select"
        value={type}
        onChange={(e) => onTypeChange(e.target.value)}
        style={{ flex: "0 1 148px" }}
      >
        {CONTRACT_TYPE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Input>
      <Input
        type="select"
        value={paymentStatus}
        onChange={(e) => onPaymentStatusChange(e.target.value)}
        style={{ flex: "0 1 168px" }}
      >
        {PAYMENT_STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Input>
      <Input
        type="select"
        value={phase}
        onChange={(e) => onPhaseChange(e.target.value)}
        style={{ flex: "0 1 168px" }}
      >
        <option value="">All phases</option>
        {(phases || []).map((p) => (
          <option key={p.id} value={p.id}>{p.name}</option>
        ))}
      </Input>
      <Input
        type="select"
        value={year}
        onChange={(e) => onYearChange(e.target.value)}
        style={{ flex: "0 1 128px" }}
      >
        <option value="">Any year</option>
        {(years || []).map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </Input>
      {hasAnyFilter && (
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={onClear}
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default ContractFilterBar;
